// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__rvLOJ","container":"Checkbox_container__jSsYy","label":"Checkbox_label__vlVly"};